import {
	type Control,
	Controller,
	type ControllerRenderProps,
	type FieldValues,
	type Path,
} from 'react-hook-form'

type FormFieldProps<T extends FieldValues, TName extends Path<T>> = {
	name: TName
	control: Control<T>
	render: (props: {
		field: ControllerRenderProps<T, TName>
	}) => React.ReactElement
}

export function FormField<T extends FieldValues, TName extends Path<T>>({
	name,
	control,
	render,
}: FormFieldProps<T, TName>) {
	return (
		<Controller
			name={name}
			control={control}
			render={({ field }) => render({ field })}
		/>
	)
}
